exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.tabledatatd {\n    text-align: center;\n    vertical-align: middle;\n}\n", ""]);
